// Version : 0.0.1
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET GOLD LOAN PROPOSAL START ***************** */
export const goldLoanProposalListGet = (listData: any) => {
	const data = {
		GetGoldLoanProposalListToken: listData,
	};
	const url = `${API_URL}getAllGoldLoanIndexDetailsList`;
	return makeApiCall(url, data);
};
/** ***************** GET GOLD LOAN PROPOSAL END ***************** */

/** ***************** DELETE GOLD LOAN PROPOSAL START ***************** */
export const goldLoanProposalDelete = (deleteData: any) => {
	const data = {
		DeleteGoldLoanDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteParticularGoldLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** DELETE GOLD LOAN PROPOSAL END ***************** */

/** ***************** UPDATE GOLD LOAN PROPOSAL START ***************** */
export const updateGoldLoan = (updateData: any) => {
	const data = {
		UpdateGoldLoanProposalListToken: updateData,
	};
	const url = `${API_URL}updateGoldLoanProposal`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GOLD LOAN PROPOSAL END ***************** */

/** ***************** FETCH GOLD LOAN PROPOSAL START ***************** */
export const goldLoanProposalDetailsFetch = (listData: any) => {
	const data = {
		FetchAllGoldLoanKeyToken: listData,
	};
	const url = `${API_URL}fetchGoldLoanDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD LOAN PROPOSAL END ***************** */

/** ***************** ADD GOLD LOAN PROPOSAL START ***************** */
export const createNewGoldLoanProposal = (addData: any) => {
	const data = {
		GoldLoanProposalToken: addData,
	};
	const url = `${API_URL}addGoldLoanProposal`;
	return makeApiCall(url, data);
};
/** ***************** ADD GOLD LOAN PROPOSAL END ***************** */

/** ***************** GET SEARCH GOLD LOAN MEMBER START ***************** */
export const getSearchGoldLoanMember = (fetchData: any) => {
	const data = {
		GetSearchGoldLoanMemberToken: fetchData,
	};
	const url = `${API_URL}getSearchGoldLoanMember`;
	return makeApiCall(url, data);
};
/** ***************** GET SEARCH GOLD LOAN MEMBER END ***************** */

/** ***************** FETCH GOLD LOAN PROPOSAL PRODUCT START ***************** */
export const goldLoanProposalGoldProductFetch = (fetchData: any) => {
	const data = {
		FetchGoldLoanProductDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchGoldLoanProductDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD LOAN PROPOSAL PROPOSAL END ***************** */

/** ***************** APPROVE GOLD LOAN PROPOSAL START ***************** */
export const approveGoldLoanProposal = (approveData: any) => {
	const data = {
		ApproveGoldLoanProposalListToken: approveData,
	};
	const url = `${API_URL}approveGoldLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** APPROVE GOLD LOAN PROPOSAL END ***************** */

/** ***************** REVERT GOLD LOAN PROPOSAL START ***************** */
export const revertGoldLoanProposal = (revertData: any) => {
	const data = {
		RevertGoldLoanProposalListToken: revertData,
	};
	const url = `${API_URL}revertGoldLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** REVERT GOLD LOAN PROPOSAL END ***************** */
